/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Telefonbewerber1Inputs */

const de__field_telefonbewerber1 = /** @type {(inputs: _Field_Telefonbewerber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon Bewerber`)
};

/**

* @param {_Field_Telefonbewerber1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_telefonbewerber1 = /** @type {((inputs?: _Field_Telefonbewerber1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Telefonbewerber1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_telefonbewerber1(inputs)
});
export { _field_telefonbewerber1 as "_field_telefonBewerber" }